type DividerProps = {
    color?: string;
    thickness?: string;
    margin?: string;
};
export const Divider = ({ color = '#e4ebfb', thickness = '1px', margin = '1rem 0' }: DividerProps) => (
    <hr
        style={{
            border: 'none',
            borderTop: `${thickness} solid ${color}`,
            margin,
        }}
    />
);
